import { render, staticRenderFns } from "./callLog.vue?vue&type=template&id=55159c03&scoped=true"
import script from "./callLog.vue?vue&type=script&lang=js"
export * from "./callLog.vue?vue&type=script&lang=js"
import style0 from "./callLog.vue?vue&type=style&index=0&id=55159c03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55159c03",
  null
  
)

export default component.exports